<template>

    <div class="login-page">
        <Header></Header>
        <section class="login-section" style="padding-top: 100px;">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Log In</h2>
                        <form class="form" v-on:submit.prevent="loginFormSubmit">
                            <div class="input-field form-input">
                                <label for="your-email">Your Email</label>
                                <input type="text" placeholder="johndoe@email.com" id="your-email" v-model="LoginEmail"
                                       v-on:blur="yourEmail(LoginEmail)">
                                <p class="error-input" v-if="loginFlag">Email address is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="your-password">Password</label>
                                <input type="password" placeholder="*******" v-model="PasswordEmail" id="your-password"
                                       v-on:blur="yourPassword(PasswordEmail)">
                                <p class="error-input" v-if="passwordFlag">Password is required</p>
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SIGN IN</button>
                                <span v-if="FormSubmited">SIGN IN...</span>
                                <router-link class="forgot-password" to="/forgot-password">Forgot Password?</router-link>
                            </div>
                        </form>
                        <div class="google-login mt-4">
                            <!--<h2 class="text-center">OR</h2>-->
                            <!--<h2>Login with Social media</h2>-->
                            <GoogleLogin :params="params" :renderParams="renderParams" :onSuccess="onSuccess" :onFailure="onFailure"></GoogleLogin>
                        </div>
                        <!--<div class="facebook-login" v-if="facebookLoginFlag">-->
                            <!--&lt;!&ndash;<v-facebook-login app-id="233646251426756" @login="login" @sdk-init="handleSdkInit"></v-facebook-login>&ndash;&gt;-->
                            <!--<div>-->
                                <!--<v-facebook-login app-id="233646251426756" v-model="facebookLogin" @sdk-init="handleSdkInit" />-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="facebook-login" v-if="!facebookLoginFlag">-->
                            <!--<div>-->
                                <!--<button class="v-facebook-login vv-login" style="transition: background-color 0.15s ease-in-out 0s;" disabled="disabled">-->
                                    <!--<span data-v-c9fa963e="" class="v-loader loader"></span>&lt;!&ndash;&ndash;&gt;-->
                                    <!--<span>-->
                                        <!--Please wait...-->
                                     <!--</span>-->
                                <!--</button>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<style>
    .google-login >div {
        position: relative;
    }
    .custom-l {
        text-align: center;
        cursor: pointer;
    }
    .custom-l:hover {
        -webkit-box-shadow: 0 0 3px 3px rgba(66,133,244,.3) !important;
        -moz-box-shadow: 0 0 3px 3px rgba(66,133,244,.3) !important;
        box-shadow: 0 0 3px 3px rgba(66,133,244,.3) !important;
    }
    .custom-l .abcRioButtonIcon{
        top: -3px !important;
    }
    .custom-l .abcRioButtonContents span{
        color: #757575;
    }
    .google-login >div, .google-login >div >div{
        width: 100% !important;
        height: 42px !important;
        border-radius: .25rem;
        border: 1px solid #ccc;
        box-shadow: none;
    }
    .google-login .abcRioButtonIcon{
        padding: 12px !important;
        position: absolute;
        left: 0;
        top: 0;
    }
    .google-login .abcRioButtonContents{
        line-height: 40px !important;
        font-weight: 600;
    }
    .facebook-login >div {
        width: 100%;
    }
    .facebook-login button {
        position: relative;
        font-weight: 600;
        cursor: pointer !important;
    }
    .facebook-login button:hover {
        -webkit-box-shadow: 0 0 3px 3px rgba(66,133,244,.3) !important;
        -moz-box-shadow: 0 0 3px 3px rgba(66,133,244,.3) !important;
        box-shadow: 0 0 3px 3px rgba(66,133,244,.3) !important;
    }
    .facebook-login svg {
        position: absolute;
        left: 10px;
        top: 10px;
        fill: #3c57a4;
    }
    .v-facebook-login {
        width: 100%;
        border: 2px solid #ccc !important;
        box-shadow: none !important;
        background-color: #FFFFFF !important;
        color: #757575 !important;
    }
    .vv-login {
        opacity: .75;
        cursor: not-allowed;
        background-color: #2d417b;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        color: #fff;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: .5rem 1rem;
        border-radius: .25rem;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        border: 1px solid hsla(0,0%,100%,.05);
    }
    .vv-login .v-loader{
        display: block;
        width: 1.25rem;
        height: 1.25rem;
        border-radius: 50%;
        border-style: solid;
        border-width: .125rem;
        border-top-color: #8b9dc3;
        border-left-color: #fff;
        border-right-color: #fff;
        border-bottom-color: #fff;
        -webkit-animation: spin-data-v-43e1f083 2s linear infinite;
        animation: spin-data-v-43e1f083 2s linear infinite;
    }
</style>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import axios from 'axios'
    import router from '../router'
    import $ from "jquery"
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)
    import GoogleLogin from 'vue-google-login'
    // import facebookLogin from 'facebook-login-vuejs'
    import VFacebookLogin from 'vue-facebook-login-component'
    export default {
        name: 'Login',
        components: {
            'Header': Header,
            'Footer': Footer,
            VFacebookLogin,
            GoogleLogin
        },
        data() {
            return {
                loginFlag: false,
                passwordFlag: false,
                LoginEmail: '',
                PasswordEmail: '',
                FormSubmited: false,
                isConnected: false,
                name: '',
                email: '',
                personalID: '',
                facebookLoginFlag: true,
                FB: {},
                facebookLogin: {},
                scope: {},
                flag: false,
                msg: 'Welcome to Your Vue.js App',
                params: {
                    client_id: "1072022692610-s9n4ia601h5g7216a5lpdtkjrqd0fqm6.apps.googleusercontent.com"
                },
                // only needed if you want to render the button with the google ui
                renderParams: {
                    width: 250,
                    height: 50,
                    longtitle: true
                }
            }
        },
        mounted () {
            setTimeout(function () {
                if(!$('.google-login >div').html()){
                    $('.google-login >div').html('<div style="height:50px;width:250px;" class="abcRioButton abcRioButtonLightBlue custom-l"><div class="abcRioButtonContentWrapper"><div class="abcRioButtonIcon" style="padding:15px"><div style="width:18px;height:18px;" class="abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="abcRioButtonSvg"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg></div></div><span style="font-size:16px;line-height:48px;" class="abcRioButtonContents"><span id="not_signed_inqsgvoz2xk9lb" style="display: none;">Sign in with Google</span><span id="connectedqsgvoz2xk9lb" style="">Signed in with Google</span></span></div></div>');
                }
            }, 1000);
            if(router.history.current.query.email && router.history.current.query.token){
                axios
                    .get('/checkUser', {
                        params: {
                            email: router.history.current.query.email,
                            token: router.history.current.query.token
                        }
                    })
                    .then(response => {
                        Vue.$toast.open(
                            {
                                message: 'Congs Signup Success',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    })
                    .catch(error => console.log(error))
            }
        },
        watch : {
            facebookLogin:function(val) {
                if(this.scope.logout && this.facebookLogin.connected && !this.flag){
                    this.flag = true
                    this.scope.logout()
                    this.facebookLoginFlag = false
                    this.getUserData()
                }
            }
        },
        methods: {
            handleSdkInit({ FB, scope }) {
                this.FB = FB
                this.scope = scope
                // console.log('model.connected', this.scope.connected)
            },
            getUserData() {
                this.FB.api('/me', 'GET', { fields: 'id,name,email' },
                    userInformation => {
                        this.personalID = userInformation.id
                        this.email = userInformation.email
                        this.name = userInformation.name
                        if(userInformation.name){
                            this.loginWithFacebook()
                        }
                    }
                )
            },
            onSuccess(googleUser) {
                let gUser = googleUser.getBasicProfile();
                this.email = gUser.tv
                this.name = gUser.tf
                this.loginWithGoogle()
                // This only gets the user information: id, name, imageUrl and email
                // console.log(googleUser.getBasicProfile());
            },
            onFailure(googleUser) {
                console.log(googleUser);
                // This only gets the user information: id, name, imageUrl and email
                // console.log(googleUser.getBasicProfile());
            },
            yourEmail: function (msg) {
                if (!msg) {
                    this.loginFlag = true
                } else {
                    this.loginFlag = false
                }
            },
            yourPassword: function (msg) {
                if (!msg) {
                    this.passwordFlag = true
                } else {
                    this.passwordFlag = false
                }
            },
            loginWithFacebook: function (){
                axios.post('/loginWithFacebook',
                    {
                        email: this.email,
                        name: this.name,
                        personalID: this.personalID,
                        facebook: true
                    }).then(res => {
                    Vue.$toast.open(
                        {
                            message: 'Login successfully!',
                            type: 'success',
                            position: 'top-right'
                            // all other options
                        }
                    )
                    localStorage.setItem('cbs_usertoken', JSON.stringify(res.data))
                    this.LoginEmail = ''
                    this.PasswordEmail = ''
                    if(res.data.user.profileImage){
                        router.push({ path: '/artists/'+res.data.user.id })
                    } else {
                        router.push({ path: '/accounts-detail/'})
                    }
                }).catch(err => {
                    this.FormSubmited = false
                })
            },
            loginWithGoogle: function (){
                axios.post('/loginWithFacebook',
                    {
                        email: this.email,
                        name: this.name,
                        google: true
                    }).then(res => {
                    Vue.$toast.open(
                        {
                            message: 'Login successfully!',
                            type: 'success',
                            position: 'top-right'
                            // all other options
                        }
                    )
                    localStorage.setItem('cbs_usertoken', JSON.stringify(res.data))
                    this.LoginEmail = ''
                    this.PasswordEmail = ''
                    if(res.data.user.profileImage){
                        router.push({ path: '/artists/'+res.data.user.id })
                    } else {
                        router.push({ path: '/accounts-detail/'})
                    }
                }).catch(err => {
                    this.FormSubmited = false
                })
            },
            loginFormSubmit: function (event) {
                this.FormSubmited = true
                if(this.LoginEmail){
                    this.LoginEmail = this.LoginEmail.trim().toLowerCase()
                }
                axios.post('/login',
                    {
                        email: this.LoginEmail,
                        password: this.PasswordEmail
                    }).then(res => {
                    if(res.data.error == 'User does not exist'){
                        Vue.$toast.open(
                            {
                                message: 'User does not exist!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        this.FormSubmited = false
                    } else if(res.data.error == 'Password or Email is wrong'){
                        Vue.$toast.open(
                            {
                                message: 'Password or Email is wrong!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        this.FormSubmited = false
                    } else if(res.data.error == 'Please verify your email first'){
                        Vue.$toast.open(
                            {
                                message: 'Please verify your email first!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        this.FormSubmited = false
                    } else {
                        Vue.$toast.open(
                            {
                                message: 'Login successfully!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        localStorage.setItem('cbs_usertoken', JSON.stringify(res.data))
                        this.LoginEmail = ''
                        this.PasswordEmail = ''
                        if(res.data.user.profileImage){
                            router.push({ path: '/artists/'+res.data.user.id })
                        } else {
                            router.push({ path: '/accounts-detail/'})
                        }
                    }
                }).catch(err => {
                    this.FormSubmited = false
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue